import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { EventData } from '../providers/event';

@Pipe({
  name: 'sponsorData'
})

export class SponsorDataPipe implements PipeTransform {

  constructor(
    private eventData: EventData
  ) { }

  transform(value: string, clientId: string): Observable<any> {
    return this.eventData.getSponsor(clientId, value);
  }
}


// WEBPACK FOOTER //
// ./src/pipes/sponsor-data.pipe.ts